import {
	setValue,
	usernameKey,
	tokenKey,
	userIdkey,
	userIsRoot
} from '../utils/storage'

export default {
	setUserToken(state, token) {
		setValue(tokenKey, token)
		state.user.token = token
	},
	setUserName(state, username) {
		setValue(usernameKey, username)
		state.user.username = username
	},
	setUserId(state, userId) {
		setValue(userIdkey, userId)
		state.user.userId = userId
	},
	setUserRoot(state, isRoot) {
		setValue(userIsRoot, isRoot)
		state.user.isRoot = isRoot
	},
	setRoutePath: (state, path) => {
		state.routePath = path
	}
}
